import { RouterProvider } from 'react-router';
import { router } from './routes';
import { DevSettings } from './src/components/DevSettings';

export default function App() {
  return (
    <>
      <RouterProvider router={router} />
      <DevSettings />
    </>
  );
}